import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { isAuthed } from "../../auth";
import OpsConsole from "./OpsConsole";

/**
 * Obscure entry point for the operations console.
 *
 * The path segment is a shared secret configured via REACT_APP_CONSOLE_PATH_KEY.
 * It only keeps the console out of sight and out of crawlers; the actual access
 * control is the platform_admin check the API performs on every request.
 */
const CONSOLE_KEY = process.env.REACT_APP_CONSOLE_PATH_KEY || "c9f3a1be7d2456";

export default function ConsoleGate() {
  const { key } = useParams();

  // Wrong key: behave exactly like any other unknown path.
  if (key !== CONSOLE_KEY) {
    return <Navigate to={isAuthed() ? "/dashboard" : "/login"} replace />;
  }
  if (!isAuthed()) {
    return <Navigate to="/login" replace />;
  }
  return <OpsConsole />;
}
